import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { accountFaqData, clientResourceFaqData, contactUsFaqData, overviewFaqData, requestsFaqData, usersFaqData, yourProjectsFaqData } from 'mockData/development/faq';
import { FAQ } from 'src/app/core/constants/core.constant';
import * as _ from 'lodash';
import { NUMBER } from 'src/app/core/enum/core.enum';
import { FormGroup } from '@angular/forms';
import { FaqServiceService } from 'src/app/core/services/faq-service/faq-service.service';
import { FaqCategory, } from 'src/app/shared/models/faqModel';
import { ToastService } from 'src/app/shared/services/toast-service/toast.service';
import { AuthService } from 'src/app/core/services/auth-service/auth.service';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqComponent implements OnInit {
  @ViewChild('successTpl', { static: false }) successTpl!: TemplateRef<any>;
  @ViewChild('dangerTpl', { static: false }) dangerTpl!: TemplateRef<any>;
  @ViewChild('navigateAwayModal') navigateAwayModal!: TemplateRef<any>;

  isEditable: boolean = false;
  formGroups: { [key: string]: FormGroup } = {};
  mode: any = 'View';
  sectionToDelete: { tab: string, index: number } | null = null;
  constants = FAQ;
  number = NUMBER;
  overviewFaqData = overviewFaqData;
  accountFaqData = accountFaqData;
  yourProjectsFaqData = yourProjectsFaqData;
  requestsFaqData = requestsFaqData;
  usersFaqData = usersFaqData;
  contactUsFaqData = contactUsFaqData;
  clientResourceFaqData = clientResourceFaqData;
  faq: any[] = [];
  getFaqdata: any;
  isAuthenticated: boolean = false;
  selectedTab: string = this.constants.overview_tab;
  faqCategories: any;
  overview: FaqCategory;
  account: FaqCategory;
  your_project: FaqCategory;
  request: FaqCategory;
  users: FaqCategory;
  contact_us: FaqCategory;
  client_resource: any;
  your_projects: FaqCategory;
  requests: FaqCategory;
  projects: FaqCategory;
  portalType: string;
  successMessage: string;
  errorMessage: string;
  hasUnsavedChanges: boolean = false;
  permissionsData: any;

  constructor(private readonly FaqServiceService: FaqServiceService,
    private readonly authService: AuthService,
    public toastService: ToastService,
    private readonly sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    const userProfile = JSON.parse(localStorage.getItem(this.constants.userProfile));
    this.permissionsData = { ...userProfile.roleAssigned };
    this.getFaqData();
    this.checkAuthentication();
  }

  /**
 * checkAuthentication() - Asynchronously checks the user's authentication status.
 */
  public async checkAuthentication(): Promise<void> {
    this.isAuthenticated = await this.authService.isAuthenticated();
    if (this.isAuthenticated) {
      const userProfileData = localStorage.getItem(this.constants.userProfile);
      if (userProfileData) {
        const userProfile = JSON.parse(userProfileData);
        this.setPortalType(userProfile);
      }
    }
  }

  /**
 * setPortalType() - Sets the portalType property based on the userTypeId from the user profile.
 * @param userProfile - An object containing user profile information, which includes userTypeId.
 */
  public setPortalType(userProfile: any): void {
    if (userProfile.userTypeId === 1) {
      this.portalType = this.constants.customer;
    } else if (userProfile.userTypeId === 2) {
      this.portalType = this.constants.studio;
    }
  }


  /**
   * selectTab() - method to update the currently selected tab.
   * @param tab - The identifier for the tab to be selected. This is typically a string that corresponds to one of the available tabs.
  */
  selectTab(tab: string): void {
    window.scrollTo(0, 0);
    this.selectedTab = tab;
  }

  /**
   * onSelectChange() - method to render different tabs after clicking on the button 
   * @param event - The change event object associated with the select element.
  */
  onSelectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedTab = selectElement.value;
  }

  /**
 * onToggle() - Toggles the mode between 'Edit' and 'View'.
 * When the form is in edit mode, the mode is set to 'Edit'.
 * When the form is in view mode, the mode is set to 'View'.
 * This method is typically used to switch the user interface 
 * between editable and non-editable states.
 */
  onToggle(): any {
    this.mode = this.isEditable ? this.constants.view : this.constants.edit;
    this.getFaqData();
  }
 convertTextToHtml(text: string): SafeHtml {
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
    const htmlText = text
      .replace(emailRegex, '<a href="mailto:$1" class="text-link">$1</a>')
      .replace(urlRegex, '<a href="$1" class="text-link" target="_blank">$1</a>');
    return this.sanitizer.bypassSecurityTrustHtml(htmlText);
  }

  /**
   * getFaqData() - method to fetch the faq details
   */
  getFaqData(): void {
    this.FaqServiceService.getFaqdata().subscribe({
      next: (response: any) => {
        if (response) {
          this.faq = response?.faqSearch;

          // Initialize categories
          const categories = {
            overview: null,
            account: null,
            projects: null,
            requests: null,
            users: null,
            contact_us: null,
            client_resource: null
          };

          // Populate categories based on faqCategoryId
          this.faq.forEach(category => {
            const uniqueFaqs = _.uniqBy(category.faq, item => `${item.faqQuestions}&&${item.faqAnswers}`);
            switch (category.faqCategoryId) {
              case 1:
                categories.overview = {
                  ...category,
                  faq: uniqueFaqs
                };
                break;
              case 2:
                categories.account = {
                  ...category,
                  faq: uniqueFaqs
                };
                break;
              case 3:
                categories.projects = {
                  ...category,
                  faq: uniqueFaqs
                };
                break;
              case 4:
                categories.requests = {
                  ...category,
                  faq: uniqueFaqs
                };
                break;
              case 5:
                categories.users = {
                  ...category,
                  faq: uniqueFaqs
                };
                break;
              case 6:
                categories.contact_us = {
                  ...category,
                  faq: uniqueFaqs
                };
                break;
              case 7:
                categories.client_resource = {
                  ...category,
                  faq: uniqueFaqs
                };
                break;
              default:
                break;
            }
          });

          // Assign the categories to the component properties
          this.overview = categories.overview;
          this.account = categories.account;
          this.projects = categories.projects;
          this.requests = categories.requests;
          this.users = categories.users;
          this.contact_us = categories.contact_us;
          this.client_resource = categories.client_resource;
        } else {
          console.warn(this.constants.warn);
        }
      },
      error: (error) => {
        console.error(this.constants.error, error);
      },
    });
  }

  /**
   * onModeChange() - Method to get the value of mode change from child
   * @param newMode - new mode change value from parent
   */
  onModeChange(newMode: string): void {
    this.mode = newMode;
    if (this.mode == this.constants.view) {
      this.isEditable = false;
    }
    else {
      this.isEditable = true;
    }
    this.getFaqData();
  }

  /**
   * showToast() - Method to display the toast message
   * @param event - Toast data from the parent component
   */
  showToast(event: { type: string; message: string }): void {
    this.toastService.clear();
    const { type, message } = event;
    const template = type === 'success' ? this.successTpl : this.dangerTpl;
    this.successMessage = message;
    this.errorMessage = message;
    this.toastService.show(template, {
      classname: type === 'success' ? 'toast-msg' : 'bg-danger text-light',
      delay: 6000,
    });
  }

  /**
   * hasUnsavedChangesValue - method to get the unsaved changes value
   * @param event - value of unsaved changes
   */
  hasUnsavedChangesValue(event): void {
    this.hasUnsavedChanges = event;
  }
}
